import { FooterProps } from '@/types/cms'

import { Columns } from './components/Columns'
import Logos from './components/Logos'
import Products from './components/Products'
import Stoneco from './components/Stoneco'

interface Props {
  footer: FooterProps
}

export function Footer({ footer }: Props) {
  return (
    <footer
      id="Context_footer"
      className="py-32 md:py-40 px-24 w-full bg-display-900"
    >
      <div className="mx-auto max-w-screen-xl">
        <Logos hasSocialMedia={footer.hasTemplateSimple} />

        {!footer.hasTemplateSimple && (
          <Columns
            columns={footer.columns}
            infoColumn={footer.infoColumn}
            awardsColumn={footer.awardsColumn}
          />
        )}

        {footer.hasTemplateSimple && (
          <div className="flex flex-col md:flex-row md:items-center mx-auto mt-8 mb-28 w-full h-auto">
            <div className="flex flex-col gap-4">
              {footer.infoColumn.lines.map(({ text }) => (
                <p key={text} className="text-display-0 paragraph-14">
                  {text}
                </p>
              ))}
            </div>
          </div>
        )}

        {!footer.hasTemplateSimple && <Stoneco />}

        {!footer.hasTemplateSimple && <Products />}
      </div>
    </footer>
  )
}
